// The page-change lock (projectBannerUser + projectBannerDisplay on the show), Josh 14 Oct 2026:
// it goes on when the person clicks Save & Continue or Proceed Without Saving, not when the
// page-change window opens, so collaborators see the hold message only while a change runs.
//
// Both go through a transaction and are awaited: the lock must have LANDED before the save copy
// and the server renumber start (applyPageChange refuses if someone else holds it), and two
// people clicking at once cannot both take it. `db` is passed in so this can be tested without
// Firebase.

const held = (data, uid) => !!(data && data.projectBannerDisplay && data.projectBannerUser && data.projectBannerUser !== uid);

// 'taken', or 'held' when someone else is changing pages (their hold message then shows here).
// Rejects when the lock cannot be written in time; the change must not start without it.
export async function takePageChangeLock({ db, projectId, uid, timeoutMs = 10000 }) {
    const ref = db.collection('projects').doc(projectId);
    let timer;
    const timedOut = new Promise((resolve, reject) => {
        timer = setTimeout(() => reject(new Error(`Could not set the page-change lock within ${timeoutMs} ms`)), timeoutMs);
    });
    try {
        return await Promise.race([
            db.runTransaction(async (tx) => {
                const snap = await tx.get(ref);
                if (held(snap.exists ? snap.data() : null, uid)) return 'held';
                tx.update(ref, { projectBannerUser: uid, projectBannerDisplay: true });
                return 'taken';
            }),
            timedOut
        ]);
    } finally {
        clearTimeout(timer);
    }
}

// Clears the lock only when this person holds it: a Cancel never lifts someone else's lock.
// 'released' or 'not-mine'.
export async function releasePageChangeLock({ db, projectId, uid }) {
    const ref = db.collection('projects').doc(projectId);
    return db.runTransaction(async (tx) => {
        const snap = await tx.get(ref);
        const data = snap.exists ? snap.data() : null;
        if (!data || !data.projectBannerDisplay || data.projectBannerUser !== uid) return 'not-mine';
        tx.update(ref, { projectBannerUser: '', projectBannerDisplay: false });
        return 'released';
    });
}


// WEBPACK FOOTER //
// ./src/lib/page-change-lock.js